import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const CURRENT_VERSION = 3;

const DEFAULT_SIMULATION_PLANS = [
    {
        id: 1,
        planName: 'Plan 1',
        partials: [{ rLevel: 1, percentage: 100 }]
    },
    {
        id: 2,
        planName: 'Plan 2',
        partials: [
            { rLevel: 1, percentage: 50 },
            { rLevel: 2, percentage: 50 }
        ]
    },
    {
        id: 3,
        planName: 'Plan 3',
        partials: [
            { rLevel: 1, percentage: 33 },
            { rLevel: 2, percentage: 33 },
            { rLevel: 3, percentage: 34 }
        ]
    },
    {
        id: 4,
        planName: 'Plan 4',
        partials: [
            { rLevel: 2, percentage: 50 },
            { rLevel: 3, percentage: 50 }
        ]
    }
];

const useTradeBookStore = create(
    persist(
        (set) => ({
            // Selected plan ID
            selectedPlan: null,
            setSelectedPlan: (planId) => set(() => ({ selectedPlan: planId })),

            // Selected breakdown section
            selectedBreakdownSection: null,
            setSelectedBreakdownSection: (section) =>
                set(() => ({
                    selectedBreakdownSection: section
                })),

            // Strategy Sets - selected set type ('strategy' | 'noStrategy')
            selectedSetType: 'strategy',
            setSelectedSetType: (setType) => set(() => ({ selectedSetType: setType })),

            // Profitability Comparison state
            selectedProfitabilitySet: null, // { setType, setNumber }
            setSelectedProfitabilitySet: (setData) =>
                set(() => ({
                    selectedProfitabilitySet: setData
                })),

            simulationPlans: DEFAULT_SIMULATION_PLANS,
            updateSimulationPlan: (planId, updates) =>
                set((state) => ({
                    simulationPlans: state.simulationPlans.map((plan) =>
                        plan.id === planId ? { ...plan, ...updates } : plan
                    )
                })),

            simulationTradeCount: 20,
            setSimulationTradeCount: (count) =>
                set(() => ({
                    simulationTradeCount: count
                })),

            // Reset store
            reset: () =>
                set(() => ({
                    selectedPlan: null,
                    selectedBreakdownSection: null,
                    selectedSetType: 'strategy',
                    selectedProfitabilitySet: null,
                    simulationPlans: DEFAULT_SIMULATION_PLANS,
                    simulationTradeCount: 20
                }))
        }),
        {
            name: 'tradebook-storage',
            version: CURRENT_VERSION,
            partialize: (state) => ({
                selectedPlan: state.selectedPlan,
                selectedBreakdownSection: state.selectedBreakdownSection,
                selectedSetType: state.selectedSetType,
                selectedProfitabilitySet: state.selectedProfitabilitySet,
                simulationPlans: state.simulationPlans,
                simulationTradeCount: state.simulationTradeCount
            })
        }
    )
);

// eslint-disable-next-line import/prefer-default-export -- Reason: legacy suppression retained until the owning code is migrated or cleaned up.
export { useTradeBookStore };
